export default function TermAndConditions() {
  return <h1>TermAndConditions</h1>;
}
